// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__zrqwI","dragIcon":"Choice_dragIcon__1dtn_","left":"Choice_left__3yu51","input":"Choice_input__1FzEY"};